import { View } from "binder"
import { PersonnelSelectorViewModel } from "src/EnterpriseAdministration/personnelManipulation/personnelSelector";
import { PersonnelSearchableSelectorViewModel } from "src/EnterpriseAdministration/personnelManipulation/personnelSelector";
import { DeliveryCartableCollectorViewModel } from "./deliveryCartableCollector-viewModel"

export class DeliveryCartableCollectorView extends View<DeliveryCartableCollectorViewModel>{
    GetViewUniqueId(): string {
        return "V-2FDD9B67-FAEA-410D-A282-7F61CCA54F4C"
    }
    loadHtml(): string {
        let element = require('./deliveryCartableCollector.html').default;
        let style = require('./deliveryCartableCollector.less');
        return element;
    }
    constructor() {
       super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set personnelSelector(v: PersonnelSelectorViewModel) { this._personnelSelector = v; } public get personnelSelector(): PersonnelSelectorViewModel { return this._personnelSelector;} private _personnelSelector: PersonnelSelectorViewModel;    
    public set personnelName(v: string) { this._personnelName = v; } public get personnelName(): string { return this._personnelName;} private _personnelName: string;

    save() {
        this.dataContext.save();
    }

    back() {
        this.dataContext.closePopup();
    }
}
